import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";
Sentry.init({
  dsn: "https://399d9b2e0988159f56e45fd675785cc0@o4509426854133760.ingest.us.sentry.io/4509426870124544",
  sendDefaultPii: true
});
platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .catch(err => console.error(err));
